/**
 * Bento.UI Supports
 *
 * BentoDropDownWrapper
 *
 * Author: Chi Gao <chi.gao@thomsonreuters.com> @ Bento.UI
 *
 * An implementation to help third party components with dropdown to work with
 * Flexgrid
 *
 * Note: This source code needs to maintained and implemented with add-on
 * directives of the new AngularJS 1 directives
 *
 * Currently supported directives:
 *
 * ##Bento.UI
 * - Combobox
 *
 * ##UI Bootstrap
 * - Datepicker
 * - Dropdown
 * - Popover
 * - Typeahead
 *
 */

/**
 * == DO NOT CHANGE ==
 *
 * Compiled from Typescript to support class extension
 * @type {*}
 * @private
 */
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p)) d[p] = b[p];

  function __() {
    this.constructor = d;
  }

  d.prototype =
      b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var wijmo;
(function(wijmo) {
'use strict';
(function(input) {
/**
 * BentoDropDownWrapper control (abstract).
 *
 * Extends Wijmo Control Class to work with Wijmo Flexgrid
 */
var BentoDropDownWrapper = (function(_super) {
  __extends(BentoDropDownWrapper, _super);
  /**
   * Initializes a new instance of the @see:DropDown class.
   *
   * @param element The DOM element that hosts the control, or a selector for
   *     the host element (e.g. '#theCtrl').
   * @param options The JavaScript object containing initialization data for the
   *     control.
   */
  function BentoDropDownWrapper(element, options) {
    // Calling the super class to initiate this Wijmo Control.
    // The CTA <=> Dropdown linkage does not work without initiating the element
    // as a `wijmo.Control` object
    _super.call(this, element, null, false);

    /*
     // Used for append-to-parent conponents

     // ----======= Source Code from wijmo.ts =======----
     var popup;
     var ae = getActiveElement(),
     popup = <any>Control.getControl(closest(ae, '.wj-control.wj-popup'));
     if (popup && popup.owner && contains(this._e, popup.owner)) {
     return true;
     }
     */
    // This popup control needs to be associated with its original parent
    // HTMLElement that is located in the Flexgrid cell element
    this.owner = options.owner;

    // starting from wijmo version >= 403, owner property needs to be updated,
    // like this
    element[wijmo.Control._OWNR_KEY] = options.owner;

    // Add the two mandatory CSS classes to the popup element as a
    // `wijmo.Control`
    element.classList.add('wj-control');
    element.classList.add('wj-popup');
  }

  return BentoDropDownWrapper;
}(wijmo.Control));
input.BentoDropDownWrapper = BentoDropDownWrapper;
})(wijmo.input || (wijmo.input = {}));
})(wijmo || (wijmo = {}));

/**
 * AngularJS 1 directives to extend dropdown elements with wijmo.Control object
 * type
 */
(function(angular) {
'use strict';
var STOP = 'stop';

angular
    .module('bento.ui')
    /**
     * bentoFlexGridControl
     *
     * This directive is should be attached alone with the component that is
     * implemented as part of the Flexgrid cell template.
     *
     * Note: This directive SHOULD NOT be altered when adding new directive
     * supports
     *
     * Example:
     *
     * <wj-flex-grid-cell-template cell-type="CellEdit">
     *   <div bento-flex-grid-control
     *        bento-combobox
     *        placeholder="{{$value.name}}" get-data="vm.products"
     * label-name="name" searchable="true" ng-model="$value"
     * bento-append-to-parent="body"
     *        >
     *   </div>
     * </wj-flex-grid-cell-template>
     *
     */
    .directive(
        'bentoFlexGridControl',
        function() {
          return {controller: 'BentoFlexGridController'};
        })
    .controller(
        'BentoFlexGridController',
        [
          '$scope', '$element',
          function($scope, $element) {
            // Create a reference of the component HTMLElement
            // for inherited scopes from dropdown/popup to use
            //
            // The isolated `$scope` defined in this controller belongs to
            // Flexgrid reusable Cell. There is no need to worry about
            // application scope conflicts.
            $scope.bentoWijCtrlHostEl = $element[0];
          }
        ])
    /**
     * Directive extensions must be declared on the ACTUAL popup elements of the
     * input elements that are used in each custom cell template.
     *
     * All supporting directive implementations starts below.
     */


    /**
     * UI Bootstrap Component Support
     */

    // Support for `uibDatepickerPopupWrap` directive that is used by
    // `uibDatepickerPopup`
    .directive('uibDatepickerPopupWrap', DatepickerDropdownDir)

    // Support for `uibDropdownMenu` directive that is used by `uibDropdown`
    .directive('uibDropdownMenu', SimpleDropdownWrapperDir)

    // Support for `uibPopoverPopup` directive that is used by `uibPopover`
    .directive('uibPopoverPopup', SimpleDropdownWrapperDir)

    // Support for `uibPopoverTemplatePopup` directive that is used by
    // `uibPopover`
    .directive('uibPopoverTemplatePopup', SimpleDropdownWrapperDir)
    // Support for `uibTypeahead` directive that is used by `uibPopover`
    .directive('uibTypeaheadPopup', SimpleDropdownWrapperDir)
    /**
     * Bento.UI Component Support
     */

    // Support for `bentoComboboxContainer` directive that is used by
    // `bentoCombobox`
    .directive(
        'bentoComboboxContainer',
        function() {
          return {
            link: function(scope, element, attrs) {
              var grid;
              var isEnterKeyboardEvent;

              // Call default link function
              if (defaultLink(scope, element) !== STOP &&
                  (grid = getGrid(scope))) {
                // Make sure that we are hijacking Keyboard Enter key from
                // Combobox directive
                scope.$parent.bentoWijCtrlHostEl.addEventListener(
                    'keydown', function(e) {
                      if (e.keyCode === 13) {
                        isEnterKeyboardEvent = true;
                      }
                    }, true);

                // Continue if this directive is in a grid
                // Get grid ref
                grid.cellEditEnding.addHandler(onCellEndingCallback);
                // Cleanup
                scope.$on('$destroy', function() {
                  grid.cellEditEnding.removeHandler(onCellEndingCallback);
                });
              }

              // Find grid ref
              function getGrid(s) {
                if (s.$row) {
                  return s.$row.grid;
                } else if (!s.$parent) {
                  return null;
                } else {
                  return getGrid(s.$parent);
                }
              }

              // Virtually click the .selected row to update Combobox's
              // `ngModel`
              function onCellEndingCallback(grid, e) {
                var selectedRow = element[0].querySelector('.selected');
                try {
                  // Select row prior to cell edit end
                  if (!isEnterKeyboardEvent) {
                    // Only auto select when it is not a keyboar Enter event
                    selectedRow.click();
                  } else {
                    // Reset Keyboard Enter event flag
                    isEnterKeyboardEvent = false;
                  }

                } catch (e) { /* Ignore input not found error since this
                                   directive is destroyed immediately  */
                }
              }
            }
          };
        })

    ;  // Module

/**
 * A simple AngularJS 1 directive wrapper definition to add
 * `BentoDropDownWrapper` (wijmo.Control) support to its dropdown/popup elements
 *
 * @returns {{link: link}}
 * @constructor
 */
function SimpleDropdownWrapperDir() {
  return {link: defaultLink};
}

function DatepickerDropdownDir() {
  return {
    link: function(scope, element, attrs, ctrls) {
      defaultLink(scope, element, attrs, ctrls);

      var lookupCounters = [0, 0];
      scope.$watch('isOpen', function(isOpen) {
        if (isOpen) {
          Object.defineProperty(document.body, wijmo.Control._OWNR_KEY, {
            get: function() {
              // 0, 0, 1, 1, reset, 0, 0 ...
              if (lookupCounters[0] < 2) {
                lookupCounters[0]++;
                return element[0];
              } else if (lookupCounters[1] < 2) {
                lookupCounters[1]++;
                return scope.$parent.bentoWijCtrlHostEl;
              } else {
                lookupCounters = [0, 0];
                return undefined;
              }
            },
            set: function(key) {
              return key;
            }
          });
        } else {
          document.body[wijmo.Control._OWNR_KEY] = undefined;
        }
      });
    }
  }
}

/**
 * Default link function
 * @param scope
 * @param element
 */
function defaultLink(scope, element) {
  // Do nothing if its parent CTA does not belong to a Flexgrid
  if (scope.$parent.bentoWijCtrlHostEl) {
    // Register the current dropdown HTMLElement as a `wijmo.Control`
    // See `BentoDropDownWrapper` below
    var wijCtrl = new wijmo.input.BentoDropDownWrapper(element[0], {
      // Used to associate this dropdown with its CTA
      // This is crucial to Flexgrid `onBlur` validations
      owner: scope.$parent.bentoWijCtrlHostEl
    });

    // Clean up
    scope.$on('$destroy', function() {
      var el = element[0];
      if (el.parentElement) {
        el.parentElement.removeChild(el);
      }
    });
  } else {
    return STOP;
  }
}
})(angular);